import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR DETAIL ---------------- */
export const fetchPageScore = createAsyncThunk(
	"pageScore/fetchPageScoreDetail",
	async (
		{ examinationCode, qpCode, bookletCode, valuationTypeCode },
		{ rejectWithValue },
	) => {
		try {
			const response = await api.get(
				`/v1/BookletPageScore/${bookletCode}/${examinationCode}/${qpCode}/${valuationTypeCode}/booklet`,
			);

			return response.data.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

export const createPageScore = createAsyncThunk(
	"pageScore/createPageScore",
	async (payload, { rejectWithValue }) => {
		try {
			const response = await api.post("/v1/BookletPageScore", payload);

			return response.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

export const updatePageScore = createAsyncThunk(
	"pageScore/updatePageScore",
	async (payload, { rejectWithValue }) => {
		try {
			const response = await api.put("/v1/BookletPageScore", payload);

			return response.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);
export const deletePageScore = createAsyncThunk(
	"pageScore/deletePageScore",
	async (pageScoreId, { rejectWithValue }) => {
		try {
			const response = await api.delete("/v1/BookletPageScore", {
				data: {
					pageScoreId,
				},
			});

			return response.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

const initialState = {
	data: [],
	pageScoreId: null,
	loading: false,
	error: null,
	activeFetchRequestId: null,
};
const pageScoreSlice = createSlice({
	name: "pageScore",
	initialState,
	reducers: {
		clearPageScore: (state) => {
			state.data = [];
			state.pageScoreId = null;
			state.loading = false;
			state.error = null;
			state.activeFetchRequestId = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPageScore.pending, (state, action) => {
				state.loading = true;
				state.error = null;
				state.activeFetchRequestId = action.meta.requestId;
			})
			.addCase(fetchPageScore.fulfilled, (state, action) => {
				if (state.activeFetchRequestId !== action.meta.requestId) return;

				state.loading = false;
				state.data = action.payload;
				state.activeFetchRequestId = null;
			})
			.addCase(fetchPageScore.rejected, (state, action) => {
				if (state.activeFetchRequestId !== action.meta.requestId) return;

				state.loading = false;
				state.error = action.payload;
				state.activeFetchRequestId = null;
			})

			.addCase(createPageScore.pending, (state) => {
				state.loading = true;
			})
			.addCase(createPageScore.fulfilled, (state, action) => {
				state.loading = false;

				const payload = action.meta.arg;
				const pageScoreId = action.payload.data;
				state.pageScoreId = pageScoreId;

				const index = state.data.findIndex(
					(item) =>
						item.questionPaperQuestionCode ===
						payload.questionPaperQuestionCode,
				);

				if (index !== -1) {
					state.data[index] = {
						...state.data[index],
						...payload,
						pageScoreId,
					};
				} else {
					state.data.push({
						...payload,
						pageScoreId,
					});
				}
			})
			.addCase(createPageScore.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})

			.addCase(updatePageScore.pending, (state) => {
				state.loading = true;
			})
			.addCase(updatePageScore.fulfilled, (state, action) => {
				state.loading = false;

				const payload = action.meta.arg;
				const index = state.data.findIndex(
					(item) => item.pageScoreId === payload.pageScoreId,
				);

				if (index !== -1) {
					state.data[index] = {
						...state.data[index],
						...payload,
					};
				}
			})
			.addCase(updatePageScore.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})
			.addCase(deletePageScore.pending, (state) => {
				state.loading = true;
			})
			.addCase(deletePageScore.fulfilled, (state, action) => {
				state.loading = false;
				state.data = state.data.filter(
					(item) => item.pageScoreId !== action.meta.arg,
				);
			})
			.addCase(deletePageScore.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearPageScore } = pageScoreSlice.actions;
export default pageScoreSlice.reducer;
